import { Controller } from "@hotwired/stimulus"
import { hasTekInSession, decryptFileWithTekPrivateKey } from "../crypto"

// Handles downloading and decrypting E2E encrypted files in the browser.
// Fetches the ciphertext via the normal download endpoint (which marks the
// attachment as downloaded and records usage server-side), then decrypts
// client-side with the TEK private key and triggers a browser download.
export default class extends Controller {
  static values = {
    downloadUrl: String,
    ephemeralPublicKey: String,
    iv: String,
    salt: String,
    filename: String,
    contentType: String
  }

  async download(event) {
    event.preventDefault()

    if (!(await hasTekInSession())) {
      alert("Sleutels niet beschikbaar. Log opnieuw in.")
      return
    }

    try {
      // Fetch via the download endpoint (follows redirect to blob)
      const response = await fetch(this.downloadUrlValue)
      if (!response.ok) {
        throw new Error("Bestand ophalen mislukt.")
      }

      const ciphertext = await response.arrayBuffer()

      // Decrypt with TEK private key
      const plaintext = await decryptFileWithTekPrivateKey(
        this.ephemeralPublicKeyValue,
        this.ivValue,
        ciphertext,
        this.saltValue
      )

      // Create download link
      const blob = new Blob([plaintext], { type: this.contentTypeValue || "application/octet-stream" })
      const url = URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = url
      link.download = this.filenameValue
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    } catch (error) {
      console.error("Decryption failed:", error)
      alert("Ontsleuteling mislukt. Controleer of je ingelogd bent.")
    }
  }
}
